import CustomPagination from "components/Common/CustomPagination"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import React, { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import {
  saveSewingEntryForm,
  getSewings,
  getSewingById,
  updateSewing,
  deleteSewing,
  clearSewingError,
  getCuttings
} from "store/actions"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Input,
  Row,
  Table,
} from "reactstrap"
import ConfirmDeleteModal from "components/Common/ConfirmDeleteModal"
import { toastMessage } from "helpers/utils"
import { debounce, sumBy } from "lodash"
import moment from "moment"
import CuttingSummaryCard from "../../containers/cutting/CuttingSummaryCard"
import ModalForm from "containers/sewing/ModalForm"
import SewingModalForm from "containers/sewing/SewingModalForm"

// Sewing
const SewingItemTab = props => {
  const [ selectedId, setSelectedId ] = useState(null)
  const [ page, setPage ] = useState(1)
  const [ pageSize, setPageSize ] = useState(10)
  const [ term, setTerm ] = useState("")

  const [ modalAddIsOpen, setModalAddIsOpen ] = useState(false)
  const [ modalEditIsOpen, setModalEditIsOpen ] = useState(false)
  const [ modalConfirmDeleteIsOpen, setModalConfirmDeleteIsOpen ] =
      useState(false)
  const {
    getCuttings,
    getSewings,
    saveSewingEntryForm,
    getSewingById,
    updateSewing,
    deleteSewing,
    clearSewingError,
    purchaseOrderId,
    cutting,
    sewing,
  } = props

  const {
    items,
    clothingSizes,
    purchaseOrderItems,
    item,
    message,
    itemCount,
    pageCount,
    loading,
    summary
  } = sewing

  const { summary: cuttingSummary } = cutting

  const debouncedQuickSearch = useCallback(
      debounce(term => {
        setTerm(term)
        setPage(1)
      }, 1000),
      []
  )

  useEffect(() => {
    getCuttings({ purchaseOrderId })
  }, [])

  useEffect(() => {
    getSewings({ purchaseOrderId, term, page, pageSize })
  }, [ page, pageSize, term ])

  useEffect(() => {
    if (message) {
      toastMessage(message)
      clearSewingError()
    }
  }, [ message ])

  const handleSubmit = items => {
    saveSewingEntryForm({
      purchaseOrderId,
      items,
    })
    
    setModalAddIsOpen(false)
  }

  const handleUpdate = data => {
    updateSewing(data)
    setModalEditIsOpen(false)
  }

  const handleDelete = () => {
    deleteSewing({ purchaseOrderId, id: selectedId })
    setModalConfirmDeleteIsOpen(false)
  }

  return (
      <div>
        <Card className="mb-1">
          <CardHeader className="bg-transparent border-bottom">
            <Row className="g-1">
              <Col md={ 2 }>
                <div className="search-box me-2 mb-2 d-inline-block">
                  <div className="position-relative">
                    <Input
                        type="text"
                        placeholder="Quick Search ..."
                        onChange={ e => {
                          const { value } = e.target
                          debouncedQuickSearch(value)
                        } }
                    ></Input>
                    <i className="fas fa-search search-icon"/>
                  </div>
                </div>
              </Col>
              <Col md={ 10 }>
                <div className="text-sm-end">
                  <Button
                      type="button"
                      color="primary"
                      className="me-1"
                      onClick={ () => setModalAddIsOpen(true) }
                  >
                    <i className="fas fa-plus"/> Add New
                  </Button>
                </div>
              </Col>
            </Row>
          </CardHeader>
        </Card>
        { loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary m-1" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
        ) : (
            <>
              {
                  cuttingSummary &&
                  <CuttingSummaryCard title={ "Cutting Summary" } summary={ cuttingSummary }/>
              }
              {
                  summary &&
                  <CuttingSummaryCard title={ "Sewing Summary" } summary={ summary }/>
              }
              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  <CardTitle>Item Entries</CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div
                        className="table-responsive mb-0"
                        data-pattern="priority-columns"
                    >
                      <Table
                          id="tech-companies-1"
                          className="table table-striped table-bordered table-nowrap"
                      >
                        <thead>
                        <tr>
                          <th style={ { width: "80px" } }>#</th>
                          <th className="text-center">Item Code</th>
                          <th className="text-center">Size</th>
                          <th className="text-center">Quantity</th>
                          <th className="text-center">Created Date</th>
                          <th className="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        { items.map((item, index) => {
                          const { sewingEntries } = item
                          let num = (page - 1) * pageSize + (index + 1)

                          let total = sumBy(sewingEntries, sewingEntry => {
                            return sewingEntry.quantity
                          })

                          return (
                              <tr key={ index }>
                                <td style={ { textAlign: "right" } }>{ num }</td>
                                <td>
                                  { item.itemCode } - { item.itemName }
                                </td>
                                <td>{ item.clothingSizeName }</td>
                                <td className="text-end">{ item.quantity }</td>
                                <td className="text-end">
                                  { moment
                                      .utc(item.createdDate)
                                      .local()
                                      .format("DD-MMM-yyyy h:mm:ss a") }
                                </td>
                                <td>
                                  <div className="d-flex justify-content-center">
                                    <div className="d-flex gap-3">
                                      <Link className="text-primary" to="#">
                                        <i
                                            className="mdi mdi-pencil font-size-18"
                                            id="edittooltip"
                                            onClick={ () => {
                                              getSewingById(item.id)
                                              setModalEditIsOpen(true)
                                            } }
                                        ></i>
                                      </Link>

                                      <Link className="text-danger" to="#">
                                        <i
                                            className="mdi mdi-delete font-size-18"
                                            id="deletetooltip"
                                            onClick={ () => {
                                              setSelectedId(item.id)
                                              setModalConfirmDeleteIsOpen(true)
                                            } }
                                        ></i>
                                      </Link>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                          )
                        }) }
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <CustomPagination
                      itemCount={ itemCount }
                      currentPage={ page }
                      totalPage={ pageCount }
                      defaultPageSize={ pageSize }
                      pageSizeOptions={ [ 5, 10, 20, 30, 40, 50, 100 ] }
                      onChangePage={ i => setPage(i) }
                      onPageSizeChange={ size => {
                        setPage(1)
                        setPageSize(size)
                      } }
                  />
                </CardBody>
              </Card>
            </>
        ) }

        <SewingModalForm
            title="Add Sewing Item Entries"
            isOpen={ modalAddIsOpen }
            toggle={ () => setModalAddIsOpen(!modalAddIsOpen) }
            clothingSizes={ clothingSizes }
            purchaseOrderItems={ purchaseOrderItems }
            purchaseOrderId={ purchaseOrderId }
            onSubmit={ handleSubmit }
        />

        { item ? (
            <ModalForm
                title="Edit Sewing Item"
                purchaseOrderId={ purchaseOrderId }
                item={ item }
                isOpen={ modalEditIsOpen }
                clothingSizes={ clothingSizes }
                toggle={ () => setModalEditIsOpen(!modalEditIsOpen) }
                onSubmit={ handleUpdate }
            />
        ) : null }

        <ConfirmDeleteModal
            title="Confirm Delete"
            isOpen={ modalConfirmDeleteIsOpen }
            toggle={ () => setModalConfirmDeleteIsOpen(!modalConfirmDeleteIsOpen) }
            onSubmit={ handleDelete }
        />
      </div>
  )
}

SewingItemTab.propTypes = {
  purchaseOrderId: PropTypes.string,
  sewing: PropTypes.object,
  cutting: PropTypes.object,
  purchaseOrder: PropTypes.object,
  stockAdjustmentStatus: PropTypes.string,
  getSewings: PropTypes.func,
  getSewingById: PropTypes.func,
  updateSewing: PropTypes.func,
  deleteSewing: PropTypes.func,
  clearSewingError: PropTypes.func,
  saveSewingEntryForm: PropTypes.func,
  getCuttings: PropTypes.func,
}

const mapStateToProps = ({ cutting, sewing }) => {
  return {
    cutting,
    sewing,
  }
}

export default withRouter(
    connect(mapStateToProps, {
      getSewings,
      saveSewingEntryForm,
      getSewingById,
      updateSewing,
      deleteSewing,
      clearSewingError,
      getCuttings
    })(SewingItemTab)
)
